import { Fragment, useState } from 'react';
import { useParams } from 'react-router';
import { IPage } from '../Components/Page';
import { eventStore, GateDirection, IStoreEvent, IStoreGate } from '../Services/EventsStore';
import { useInitAsync } from '../Utils';
import Home from './Home';
import Button from '@mui/material/Button';
import { useOperation } from '../Hooks/OperationContext';
import Title from '../Components/Title';
import { enter, exit, playSoundAsync, vibrate } from '../Services/SoundPlayer';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import apiClient from '../Services/ApiClient';
import session from '../Services/Session';
import { appSettings } from '../AppSettings';
import CachedIcon from '@mui/icons-material/Cached';
import { useNetwork } from '../Hooks/Network';
import { useActions } from '../Hooks/Actions';
import "./Counter.scss"

interface ICounterProps {
    event?: IStoreEvent;
    gate?: IStoreGate;
}

export function CounterContent(props: ICounterProps) {

    const [event, setEvent] = useState(props.event);

    const [gate, setGate] = useState(props.gate);

    const network = useNetwork();

    const actions = useActions();

    const operation = useOperation();

    let { eventId, gateId } = useParams();

    const [ direction, setDirection ] = useState(GateDirection.In);

    if (!eventId)
        eventId = event?.id;

    useInitAsync(() => network(async () => {

        if (!event && eventId)
            setEvent(await eventStore.getEventByIdAsync(eventId));

        if (!gate && gateId)
            setGate(await eventStore.getEventGateAsync(eventId, gateId));
    }));

    const count = () => {
        vibrate(true);

        network(async () => {

            const result = await apiClient.updateCounterAsync({
                counter: direction === GateDirection.In ? 1 : -1,
                eventID: eventId,
                ref_gate: gate?.code ?? "0",
                ref_device: session.deviceId
            });

            if (!result)
                throw new Error("Invalid response");

            operation.showAlert(direction === GateDirection.In ? "Ingresso registrato" : "Uscita registrata", "success", 1000);

            if (direction == GateDirection.In)
                playSoundAsync(enter);
            else
                playSoundAsync(exit);
        }, { showBigError: true, disableRetry: !appSettings.showRetryOnScanError });


    }

    const onGateClick = () => {
        actions.selectGate(eventId);
    }

    const onDirectionClick = () => {
        if (direction == GateDirection.In)
            setDirection(GateDirection.Out);
        else
            setDirection(GateDirection.In);
    }


    if (!event || !gate)
        return null;

    const actionLabel = direction == GateDirection.In ? <span><AddIcon /> 1</span> : <span><RemoveIcon /> 1</span>;

    return (
        <Fragment>
            <header><Title>{event.title}</Title></header>
            <Button size="large" variant="contained" className={"count " + (direction === GateDirection.In ? "in" : "out")} onClick={count}>{actionLabel}</Button>
            <div className="fieldset">
                <div className="field" onClick={onGateClick}>
                    <label>Gate</label>
                    <span>{gate.name}</span>
                </div>
                <div className="field" onClick={onDirectionClick}>
                    <label>Direzione</label>
                    <span>{direction == GateDirection.In ? "Entrata" : "Uscita"}<CachedIcon /></span>
                </div>
            </div>
            <div className="tip">
                Clicca su DIREZIONE per passare da entrata ad uscita
            </div>
        </Fragment>
    )
}

const Counter : IPage = {

    name: "counter",
    title: "Contatore",
    route: "/count/:eventId/:gateId",
    container: Home,
    content: <CounterContent />
}

export default Counter;